import { Location, locationName } from '@cobliteam/common-types';

import { lazy } from '@cobliteam/lazy-with-retries';

const TrainingPage = lazy(() => import('@cobliteam/training/src/pages/TrainingPage'));

const routes = [
  {
    title: locationName[Location.TRAINING],
    path: Location.TRAINING,
    team: 'squad-video-xp',
    component: TrainingPage,
  },
];

export default routes;
